import styled from 'styled-components';

export const lightBg = `
  background: rgba(255, 255, 255, 0.1);
  background-image: linear-gradient(
    to right,
    rgba(255, 255, 255, 0.01) 0%,
    rgba(255, 255, 255, 0.1) 20%,
    rgba(255, 255, 255, 0.01) 40%,
    rgba(255, 255, 255, 0.01) 100%
  );
`;

export const darkBg = `
  background: rgba(50, 50, 50, 0.1);
  background-image: linear-gradient(
    to right,
    rgba(50, 50, 50, 0.01) 0%,
    rgba(50, 50, 50, 0.1) 20%,
    rgba(50, 50, 50, 0.01) 40%,
    rgba(50, 50, 50, 0.01) 100%
  );
`;

const shimmerAnimation = `
  @keyframes shimmer {
    0% {
      background-position: -100% 0;
    }
    100% {
      background-position: 100% 0;
    }
  }
`;

export const loadingAnimation = `
  ${shimmerAnimation}
  background-repeat: no-repeat;
  background-size: 300%;
  box-sizing: border-box;
  animation-duration: 1s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: shimmer;
  animation-timing-function: linear;
`;

interface LoadingMaskProps {
  width?: string;
  height?: string;
  isDark?: boolean;
  isRound?: boolean;
}

const LoadingMask = styled.div<LoadingMaskProps>`
  width: ${props => props.width || '100%'};
  height: ${props => props.height || '100%'};
  border-radius: ${props => (props.isRound ? '999px' : 'none')};

  ${props => (props.isDark ? darkBg : lightBg)}
  ${loadingAnimation}
`;

export default LoadingMask;
